module.exports = __webpack_public_path__ + "img/user_logo.675444b3.jpg";